import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';

interface AppButtonProps {
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps<Theme>;
  [key: string]: any; // allows for additional props to be passed in
}

const AppButton: React.FC<AppButtonProps> = ({ text, onClick, sx, ...props }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        backgroundColor: 'rgba(88, 175, 188, 0)',
        border: '1px solid',
        color: 'white',
        borderRadius: '20px',
        padding: '10px 20px',
        '&:hover': { backgroundColor: 'white', color: 'black' },
        ...sx, // allows for additional custom styles to be passed in
      }}
      {...props} // allows for additional props to be passed in
    >
      {text}
    </Button>
  );
};

export default AppButton;
